import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Table,
  CircularProgress,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  TablePagination,
} from "@mui/material";
import "./dashboard.css";
import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalStyles } from "@mui/system";
import GroupIcon from "@mui/icons-material/Group";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IoIosPeople } from "react-icons/io";
import { BsPersonCheckFill } from "react-icons/bs";
import { BsFillPersonXFill } from "react-icons/bs";
import { format } from "date-fns"; // Import the format function
import { useAuth } from "../../../AuthProvider";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const Dashboard = () => {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [presentsCount, setPresentsCount] = useState(0);
  const [attendance, setAttendance] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const navigate = useNavigate();
  const [isEditingCheckIn, setIsEditingCheckIn] = useState(false); // State to toggle check-in input field
  const [isEditingCheckOut, setIsEditingCheckOut] = useState(false); // State to toggle check-out input field

  const { oId ,pId} = useAuth();

  //dialog open code
  const [open, setOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [checkIn, setCheckIn] = useState(selectedEmployee?.checkIn || ""); // Initial check-in time
  const [checkOut, setCheckOut] = useState(selectedEmployee?.checkOut || "");
  const [dateId, setDateId] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null); // To store the timeout ID

  const handleOpenModal = (employee) => {
    setSelectedEmployee(employee);
    setDateId(employee.id);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedEmployee(null);
  };

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const todayDate = getTodayDate();

 
  // useEffect(() => {
  //   const fetchEmployeeCount = async () => {
  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/employee/count/by-organisation/${oId}`
  //       );
  //       const data = await response.json();
  //       console.log("Employee Count Response:", data); // Debugging

  //       if (typeof data === "number") {
  //         setEmployeeCount(data);
  //       } else {
  //         console.error("Unexpected API response:", data);
  //         setEmployeeCount(0); // Fallback value
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch employee count", error);
  //       setEmployeeCount(0); // Fallback value
  //     }
  //   };

  //   fetchEmployeeCount();
  // }, [oId]);

  useEffect(() => {
    const fetchPresentsCount = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/attendance/employees/count/${todayDate}/${oId}/${pId}`
        );
        const data = await response.json();

        // Extract the present and total values from the response
        setPresentsCount(data); // Update present count
        // setEmployeeCount(data.total); // Update total employee count
      } catch (error) {
        console.error("Failed to fetch presents count", error);
      }
    };

    fetchPresentsCount();
  }, [todayDate]);

  // Calculate the absent count based on total and present employees
  // const totalAbsent = employeeCount - presentsCount;

  useEffect(() => {
    const fetchAllAttendance = async () => {
      try {
        setLoader(true);
        const response = await fetch(
          `${baseUrl}/api/attendance/employees/all/${todayDate}/${oId}/${pId}`
        );
        const data = await response.json();

        const todayAttendace = data.filter(
          (employee) => employee.date === todayDate
        );
        const employeesWithImages = todayAttendace.map((employee) => ({
          ...employee,
          checkInPic: `data:image/jpeg;base64,${employee.checkInPic}`,
          checkOutPic: `data:image/jpeg;base64,${employee.checkOutPic}`,
        }));

        // Sort employeesWithImages so newly added rows appear on top
        const sortedAttendance = employeesWithImages.reverse();

        // Extract all IDs and set them in the state

        setAttendance(sortedAttendance);
      } catch (error) {
        console.error("Failed to fetch attendance", error);
      } finally {
        setLoader(false);
      }
    };

    fetchAllAttendance();
  }, [todayDate]);

  //for punch in location
  const truncateString = (str, num) => {
    if (typeof str !== "string") {
      return "Punch In Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };
  //for punch out location
  const truncateString1 = (str, num) => {
    if (typeof str !== "string") {
      return "Punch Out Location Not Found";
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  // const formatTimeFromArray = (timeArray) => {
  //   if (Array.isArray(timeArray) && timeArray.length >= 2) {
  //     const hours = String(timeArray[0]).padStart(2, "0");
  //     const minutes = String(timeArray[1]).padStart(2, "0");
  //     return `${hours}:${minutes}`;
  //   }
  //   return "N/A";
  // };

  // const attendanceNavigation = () => {
  //   navigate("/employeeAttendance");
  // };

  const employeeClick = () => {
    navigate("/Employee");
  };

  const handleAbsents = () => {
    navigate("/AbsentsList");
  };

  const handlePresents = () => {
    navigate("/EmployeeAttendance");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to handle API call for updating punch details
  const updatePunchDetails = async (updatedData) => {
    // Format checkIn and checkOut to 'hh:mm a' format for proper API sending
    const formattedCheckIn = checkIn
      ? format(new Date(checkIn), "hh:mm a")
      : selectedEmployee?.checkIn;
    const formattedCheckOut = updatedData.checkOut
      ? updatedData.checkOut
      : selectedEmployee?.checkOut; // Ensure it's the correctly formatted value

    const url = `${baseUrl}/api/attendance/time/${dateId}?checkIn=${formattedCheckIn}&checkOut=${formattedCheckOut}`;

    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(url, options);

      if (response.ok) {
        const data = await response.json();
        console.log("Punch details updated successfully:", data);

        toast.success("Punch details updated successfully!", {
          position: "top-right",
          autoClose: 1000, // Close after 1 second
        });
        setOpen(false);
        return data;
      } else {
        const errorData = await response.json();
        console.error("Error updating punch details:", errorData);

        toast.error("Error updating punch details", { position: "top-right" });

        throw new Error("Error updating punch details");
      }
    } catch (error) {
      console.error("Error during API call:", error);

      toast.error("Error during API call", { position: "top-right" });

      throw new Error("Error during API call");
    }
  };

  // Handle the check-in update
  const handleCheckInBlur = () => {
    const updatedData = {
      checkIn: checkIn || selectedEmployee.checkIn,
      checkOut: checkOut || selectedEmployee.checkOut, // Send both values
    };
    updatePunchDetails(updatedData);
    setIsEditingCheckIn(false);
  };

  const handleCheckOutBlur = () => {
    // If there's a previous timeout, clear it
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Set a new timeout to delay the API call by 1 second (1000ms)
    const newTimeoutId = setTimeout(async () => {
      // Log the raw checkOut value
      console.log("checkOut before formatting:", checkOut);

      // Ensure checkOut is a valid Date object
      const checkOutDate = new Date(checkOut);
      console.log("checkOut as Date:", checkOutDate);

      // If the time is in the AM and you need PM, forcefully update it
      if (checkOutDate.getHours() < 12) {
        // if it's AM (0-11 hours)
        checkOutDate.setHours(checkOutDate.getHours() + 12); // Convert to PM
      }

      // Format the time in 'hh:mm aa' format (e.g., '06:30 PM')
      const formattedCheckOut = checkOut
        ? format(checkOutDate, "hh:mm aa")
        : "N/A";
      console.log("Formatted CheckOut Time:", formattedCheckOut);

      const updatedData = {
        checkIn: checkIn
          ? format(new Date(checkIn), "hh:mm aa")
          : selectedEmployee.checkIn,
        checkOut: formattedCheckOut || selectedEmployee.checkOut,
      };

      try {
        await updatePunchDetails(updatedData); // Call the API with formatted data
        setIsEditingCheckOut(false); // Close the editor
      } catch (error) {
        console.error("Error updating punch details:", error);
      }
    }, 1000); // 1 second delay

    setTimeoutId(newTimeoutId); // Save the timeout ID to clear if needed
  };

  return (
    <Box p={3} marginTop={9}>
      <Grid container spacing={1}>
        {/* Employess Count */}
        <Grid item xs={12} sm={4}>
          <Paper
            style={{
              ...cardStyle,
              borderBottom: `4px solid #007bff`,
              minHeight: "70px",
              cursor: "pointer",
              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition
            }}
            onClick={() => navigate("/Employee")} // Navigate to "/students"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)"; // Lift on hover
              e.currentTarget.style.boxShadow =
                "0px 12px 20px rgba(0, 0, 0, 0.15)"; // Enhanced shadow on hover
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"; // Reset position
              e.currentTarget.style.boxShadow =
                "0px 8px 15px rgba(0, 0, 0, 0.1)"; // Reset shadow
            }}
          >
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{ height: "100%" }}
            >
              <Grid item>
                <Grid container alignItems="center">
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#cce5ff", // Lighter background color for blue
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IoIosPeople
                      style={{ fontSize: "17px", color: "#007bff" }}
                    />
                  </div>
                  <Typography
                    variant="h6"
                    style={{ marginLeft: "8px", fontWeight: "bold" }}
                  >
                    TOTAL EMPLOYEES
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  style={{ color: "#007bff", fontWeight: "bold" }}
                >
                  {presentsCount.total || 0}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Prenet Count */}
        <Grid item xs={12} sm={4}>
          <Paper
            style={{
              ...cardStyle,
              borderBottom: `4px solid #28a745`,
              minHeight: "70px",
              cursor: "pointer",
              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition
            }}
            onClick={() => navigate("/EmployeeAttendance")} // Navigate to "/students"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)"; // Lift on hover
              e.currentTarget.style.boxShadow =
                "0px 12px 20px rgba(0, 0, 0, 0.15)"; // Enhanced shadow on hover
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"; // Reset position
              e.currentTarget.style.boxShadow =
                "0px 8px 15px rgba(0, 0, 0, 0.1)"; // Reset shadow
            }}
          >
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{ height: "100%" }}
            >
              <Grid item>
                <Grid container alignItems="center">
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#d4edda", // Lighter background color for blue
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <BsPersonCheckFill
                      style={{ fontSize: "17px", color: "#28a745" }}
                    />
                  </div>
                  <Typography
                    variant="h6"
                    style={{ marginLeft: "8px", fontWeight: "bold" }}
                  >
                    TOTAL PRESENT
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  style={{ color: "#28a745", fontWeight: "bold" }}
                >
                  {presentsCount.present || 0}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Absent Count */}
        <Grid item xs={12} sm={4}>
          <Paper
            style={{
              ...cardStyle,
              borderBottom: `4px solid #dc3545`,
              minHeight: "70px",
              cursor: "pointer",
              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition
            }}
            onClick={() => navigate("/AbsentsList")} // Navigate to "/students"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)"; // Lift on hover
              e.currentTarget.style.boxShadow =
                "0px 12px 20px rgba(0, 0, 0, 0.15)"; // Enhanced shadow on hover
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"; // Reset position
              e.currentTarget.style.boxShadow =
                "0px 8px 15px rgba(0, 0, 0, 0.1)"; // Reset shadow
            }}
          >
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              style={{ height: "100%" }}
            >
              <Grid item>
                <Grid container alignItems="center">
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      backgroundColor: "#f8d7da", // Lighter background color for blue
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <BsFillPersonXFill
                      style={{ fontSize: "17px", color: "#dc3545" }}
                    />
                  </div>
                  <Typography
                    variant="h6"
                    style={{ marginLeft: "8px", fontWeight: "bold" }}
                  >
                    TOTAL ABSENT
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  style={{ color: "#dc3545", fontWeight: "bold" }}
                >
                  {presentsCount.absent || 0}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Box mt={5}>
        <Card
          sx={{
            backgroundColor: "white",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Typography sx={{ fontSize: 18, padding: 1, textAlign: "center" }}>
            <strong style={{ padding: 12 }}>Daily Employee Attendance</strong>
          </Typography>
          <CardContent>
            <GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />
            <TableContainer
              component={Paper}
              style={{ maxHeight: "500px", overflowY: "auto" }}
              className="custom-sidebar-scrollbar"
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "S.No",
                      // "Thumbnail",
                      "Employee Name",
                      "Date",
                      "Punch In Time",
                      "Punch Out Time",
                      "Location",
                      "Status",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px",
                          textAlign: "center",
                          backgroundColor: "#fff9c4",
                          fontWeight: "Bold",
                          fontSize: "14px",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                        >
                          <CircularProgress />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading Data...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : attendance.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </TableCell>
                    </TableRow>
                  ) : (
                    attendance.map((employee, index) => (
                      <TableRow
                        key={employee.id}
                        sx={{
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                          "&:hover": { backgroundColor: "#f5f5f5" }, // Hover effect
                         
                        }}
                      >
                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "50px",
                            minWidth: "50px",
                            whiteSpace: "nowrap",
                             fontSize:'15px'
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        {/* <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px",
                            minWidth: "50px",

                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column", // Stack items vertically
                              alignItems: "center", // Center horizontally
                              justifyContent: "center", // Center vertically
                            }}
                          >
                            <Avatar
                              alt={employee.firstName}
                              src={employee.checkInPic}
                              sx={{
                                width: 30,
                                height: 30,
                                cursor: "pointer",
                                marginBottom: "5px",
                              }}
                              onClick={() => handleOpenModal(employee)}
                            />
                            <Typography variant="body2">
                              {employee.employeeId}
                            </Typography>
                          </Box>
                        </TableCell> */}

                        <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "2px",
    textAlign: "center",
    maxWidth: "80px",
    minWidth: "80px",
  }}
>
  <Box
    sx={{
      whiteSpace: "normal",       // Allow wrapping
      wordBreak: "break-word",    // Break long words
      overflowWrap: "break-word",
      fontSize: "13px",
    }}
  >
    {employee.firstName} {employee.lastName}
  </Box>
</TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.date}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.checkIn || "Not Punched in Yet"}
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            padding: "2px",
                            textAlign: "center",
                            maxWidth: "80px",
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                             color:"black",
                            fontSize:'13px'
                          }}
                        >
                          {employee.checkOut || "Not Punched out Yet"}
                        </TableCell>

                        {/* <TableCell
    sx={{
      borderRight: "1px solid #ddd",
      padding: "2px",
      textAlign: "center",
      maxWidth: "120px",
      minWidth: "100px",
    }}
  >
    <Typography variant="body2" sx={{ fontSize: "13px" }}>
      {truncateString(employee.checkinLocation, 300)}
    </Typography>
    <Divider sx={{ my: 1, backgroundColor: "black" }} />
    <Typography variant="body2" sx={{ fontSize: "13px" }}>
      {truncateString1(employee.checkoutLocation, 300)}
    </Typography>
  </TableCell> */}

                        <TableCell
                          style={{
                            color: "black",
                            // fontSize: "15px",
                            textAlign: "center",
                            // border: "1px solid black",
                            padding: 0, // Remove padding from the cell
                            verticalAlign: "top", // Ensure content is aligned to the top
                            maxWidth: "300px",
                            // minWidth: "100px",
                          }}
                        >
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            width="100%" // Ensure the box takes up the full width
                            sx={{ borderRight: "1px solid #ddd" }}
                          >
                            {/* Check-in location */}
                            <Box
                              style={{
                                width: "100%",
                                maxHeight: "45px", // Set a max height for the check-in section
                                overflowY: "auto", // Enable vertical scrolling if content overflows
                                padding: "8px 0",
                                borderRight: "1px solid #ddd",
                                 color:"black",
                            fontSize:'13px'
                              }}
                            >
                              <Typography variant="body2" style={{}}>
                                {truncateString(employee.checkinLocation, 300)}
                              </Typography>
                            </Box>

                            {/* Divider Line */}
                            <Box
                              component="hr"
                              style={{
                                width: "100%",
                                border: "none", // Remove default border
                                height: "1px", // Set line height to 1px for thinness
                                backgroundColor: "#ddd", // Set the line color to black
                                marginTop: "5px",
                              }}
                            />

                            {/* Check-out location */}
                            <Box
                              style={{
                                width: "100%",
                                maxHeight: "50px", // Set a max height for the check-out section
                                overflowY: "auto", // Enable vertical scrolling if content overflows
                                padding: "8px 0",
                                 color:"black",
                            fontSize:'13px'
                              }}
                            >
                              <Typography variant="body2" style={{}}>
                                {truncateString1(
                                  employee.checkoutLocation,
                                  300
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>

                        <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "2px",
    textAlign: "center",
    maxWidth: "80px",
    minWidth: "80px",
    whiteSpace: "nowrap",
  }}
>
  <Box
    sx={{
      display: "inline-block",
      padding: "6px 12px",
      borderRadius: "20px",
      fontWeight: "bold",
      color: ["Employee", "Admin","STUDENT", "Device"].includes(employee.status) ? "#fff" : "#fff",
      background: ["Employee", "Admin","STUDENT", "Device"].includes(employee.status)
        ? "linear-gradient(45deg, #66bb6a, #43a047)" // Green gradient for Present
        : "linear-gradient(45deg, #e57373, #e53935)",  // Red gradient for Absent
      textAlign: "center",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Add some shadow for elevation
      minWidth: "70px", // Ensure more width for better appearance
      transition: "all 0.3s ease-in-out", // Smooth hover effect
      "&:hover": {
        transform: "translateY(-3px)", // Slight hover animation
        boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.3)", // Enhanced shadow on hover
      },
    }}
  >
    {["Employee", "Admin","STUDENT", "Device"].includes(employee.status) ? "Present" : "Absent"}
  </Box>
</TableCell>


                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      <Dialog open={open} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {/* <strong style={{ fontSize: '20px' }}>Punch Details</strong> */}
          <strong style={{ fontSize: "20px" }}>
            Punch Details -
            <strong style={{ color: "#7e31ce" }}>
              {" "}
              {selectedEmployee?.firstName} {selectedEmployee?.lastName}{" "}
            </strong>
          </strong>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "black", // Change the color to your desired value
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {selectedEmployee && (
            <Box gap={2}>
              {/* Punch In Details */}
              <Card sx={{ maxWidth: 900 }}>
                <strong
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    color: "#0c8091",
                  }}
                >
                  Punch In Details
                </strong>
                <CardContent>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={2}
                  >
                    <Avatar
                      alt="Punch In Photo"
                      src={selectedEmployee.checkInPic}
                      sx={{ width: 150, height: 150 }}
                    />
                    <Box>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                      >
                        Punch In Time:
                      </Typography>
                      {isEditingCheckIn ? (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            value={checkIn}
                            onChange={(newValue) => setCheckIn(newValue)} // Update time value
                            onAccept={() => handleCheckInBlur()} // Trigger API call when user clicks OK
                            onBlur={() => handleCheckInBlur()} // Trigger API call when user clicks outside
                            ampm // Enable AM/PM format
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                sx={{ paddingLeft: "25px" }}
                                autoFocus
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleCheckInBlur(); // Trigger API call on "Enter" key press
                                  }
                                }}
                                // Allow manual input in the time field
                                value={checkIn || ""} // Display the value, empty string if no value
                                onChange={(e) => setCheckIn(e.target.value)} // Handle manual input change
                              />
                            )}
                          />
                        </LocalizationProvider>
                      ) : (
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: "bold",
                            paddingLeft: "25px",
                            color: "Green",
                            paddingTop: 5,
                            cursor: "pointer",
                          }}
                          onClick={() => setIsEditingCheckIn(true)} // Show input field on click
                        >
                          {selectedEmployee.checkIn || "N/A"}
                        </Typography>
                      )}

                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                        mt={2}
                      >
                        Punch In Address:
                      </Typography>
                      <Typography
                        style={{ paddingLeft: "25px", paddingTop: 5 }}
                      >
                        {truncateString(selectedEmployee.checkinLocation, 300)}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              {/* Divider */}
              <Divider sx={{ width: "100%", marginY: 2 }} />

              {/* Punch Out Details */}
              <Card sx={{ maxWidth: 900, boxShadow: 1 }}>
                <strong
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    color: "#0c8091",
                  }}
                >
                  Punch Out Details
                </strong>
                <CardContent>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={2}
                  >
                    <Avatar
                      alt="Punch Out Photo"
                      src={selectedEmployee.checkOutPic}
                      sx={{ width: 150, height: 150 }}
                    />
                    <Box>
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                      >
                        Punch Out Time:
                      </Typography>
                      {/* Editable Punch Out Time */}
                      {isEditingCheckOut ? (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            value={checkOut}
                            onChange={(newValue) => setCheckOut(newValue)} // Update Punch Out Time
                            onAccept={() => handleCheckOutBlur()} // Trigger API call on Accept
                            ampm // Enable AM/PM format
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                sx={{ paddingLeft: "25px" }}
                                autoFocus
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleCheckOutBlur(); // Trigger API call on "Enter" key press
                                  }
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      ) : (
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: "bold",
                            paddingLeft: "25px",
                            color: "Green",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsEditingCheckOut(true)} // Show TimePicker on click
                        >
                          {selectedEmployee.checkOut || "N/A"}
                        </Typography>
                      )}

                      {/* Punch Out Address */}
                      <Typography
                        variant="h6"
                        style={{
                          fontWeight: "bold",
                          paddingLeft: "25px",
                          color: "#7e31ce",
                        }}
                        mt={2}
                      >
                        Punch Out Address:
                      </Typography>
                      <Typography
                        style={{ paddingLeft: "25px", paddingTop: 5 }}
                      >
                        {truncateString(selectedEmployee.checkoutLocation, 300)}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </Box>
  );
};

const cardStyle = {
  padding: "10px",
  position: "relative",
  borderRadius: "8px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  height: "40px",
};

export default Dashboard;